import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthorization } from '../../contexts/AuthorizationContext';
import './Tasklists.css';

function Tasklists() {
  const { hasPermission } = useAuthorization();

  return (
    <div className="tasklists-container">
      <div className="tasklists-grid">
        {hasPermission('CREATE_TEMPLATE') && (
          <Link to="/forms/tasklists/create" className="tasklist-tile">
            <div className="tile-icon">➕</div>
            <h2>Create Tasklist</h2>
          </Link>
        )}
        <Link to="/forms/tasklists/mylists" className="tasklist-tile">
          <div className="tile-icon">📋</div>
          <h2>My Lists</h2>
        </Link>
      </div>
    </div>
  );
}

export default Tasklists;